/**
 * Keep in sync with hct-webapp `src/core/case-history/ageCalendarDays.ts` (calendar age in days).
 */

function localDayUtcMs(d: Date): number {
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
}

export function differenceInCalendarDays(later: Date, earlier: Date): number {
  return Math.round((localDayUtcMs(later) - localDayUtcMs(earlier)) / 86400000);
}

function parseDobToLocalDate(dob: string | Date): Date | null {
  if (dob instanceof Date) {
    if (isNaN(dob.getTime())) return null;
    return new Date(dob.getFullYear(), dob.getMonth(), dob.getDate());
  }
  const t = typeof dob === "string" ? dob.trim() : "";
  if (!t) return null;

  const m = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (m) {
    const mo = parseInt(m[1]!, 10) - 1;
    const day = parseInt(m[2]!, 10);
    const y = parseInt(m[3]!, 10);
    return new Date(y, mo, day);
  }

  if (/^\d{4}-\d{2}-\d{2}/.test(t)) {
    const p = t.slice(0, 10).split("-");
    if (p.length === 3) {
      const y = parseInt(p[0]!, 10);
      const mo = parseInt(p[1]!, 10) - 1;
      const day = parseInt(p[2]!, 10);
      if (Number.isFinite(y) && Number.isFinite(mo) && Number.isFinite(day)) {
        return new Date(y, mo, day);
      }
    }
  }

  const d = new Date(t);
  if (isNaN(d.getTime())) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function computeAgeInDays(
  dobInput: string | Date | null | undefined,
  reference: Date = new Date()
): number | null {
  if (dobInput == null) return null;
  const dob = typeof dobInput === "string" || dobInput instanceof Date ? parseDobToLocalDate(dobInput) : null;
  if (!dob) return null;
  const ref = new Date(reference.getFullYear(), reference.getMonth(), reference.getDate());
  const days = differenceInCalendarDays(ref, dob);
  if (days < 0) return null;
  return days;
}
